import { authInstance } from '@/shared/api/api-instances/auth/api-instance';
import type { Page, PaginationParams } from '@/shared/api/pagination';
import type {
  LDAPCreate,
  LDAPResponse,
  LDAPServer,
  LDAPTemplate,
  LDAPUpdate,
  LDAPUserInfoTestRequest,
  LDAPUserInfoTestResponse,
} from '@/entities/user/user';
import type { AxiosRequestConfig } from 'axios';

export class LDAPApi {
  static getServers(options?: AxiosRequestConfig) {
    return authInstance.get<LDAPServer[]>(`/ldap/names`, options);
  }

  static getActiveServers(options?: AxiosRequestConfig) {
    return authInstance.get<LDAPServer[]>(`/ldap/names/active`, options);
  }

  static getTemplates(options?: AxiosRequestConfig) {
    return authInstance.get<LDAPTemplate>(`/ldap/example/templates`, options);
  }

  static async getConnections(
    params: PaginationParams,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.get<Page<LDAPResponse>>('/ldap/settings', {
      ...options,
      params,
    });
  }

  static deleteConnection(
    id: string,
    force: boolean = false,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.delete(`/ldap/${id}`, {
      ...options,
      params: { force, ...options?.params },
    });
  }

  static createConnection(payload: LDAPCreate, options?: AxiosRequestConfig) {
    return authInstance.post<LDAPResponse>('/ldap', payload, options);
  }

  static updateConnection(
    id: string,
    payload: LDAPUpdate,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.patch<LDAPResponse>(`/ldap/${id}`, payload, options);
  }

  static getConnection(id: string, options: AxiosRequestConfig = {}) {
    return authInstance.get<LDAPResponse>(`/ldap/${id}`, options);
  }

  static testUserInfo(
    payload: LDAPUserInfoTestRequest,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.post<LDAPUserInfoTestResponse>(
      `/ldap/user_info/test`,
      payload,
      options,
    );
  }
}